export default "__VITE_ASSET__B$qFreLM__"